module.exports = __webpack_public_path__ + "static/media/ju7.0875b43a.jpg";